<template>
    <v-container fluid fill-height>
        <v-layout align-center justify-center >
            <v-flex xs12 sm8 md4 class="elevation-1">
                <router-view></router-view>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
    data () {
        return {
        }
    }
}
</script>
<style>
</style>
